import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { User } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mvp-avatar',
  templateUrl: './avatar.component.html',
})
export class AvatarComponent implements OnChanges {

  @Input() user: User;
  @Input() smallInitials = false;
  assetUrl: string = environment.assetUrl;
  avatarLoadFailed = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.user) {
      this.avatarLoadFailed = false;
    }
  }

  firstLetter(word: string) {
    if (!word) {
      return '';
    }
    return word.charAt(0).toUpperCase();
  }

  getInitials() {
    const firstname = (this.user?.firstname || '').trim();
    const lastname = (this.user?.lastname || '').trim();

    if (firstname || lastname) {
      return `${this.firstLetter(firstname)}${this.firstLetter(lastname)}`;
    }

    const email = (this.user?.email || '').trim();
    return email ? email.slice(0, 2).toUpperCase() : '?';
  }

  hasAvatar() {
    return !!this.user?.avatar && !this.avatarLoadFailed;
  }

  getAvatarUrl() {
    if (!this.user.avatar) {
      return '';
    }

    return `${this.assetUrl}/avatars/${this.user.avatar}.png`;
  }

  onAvatarError() {
    this.avatarLoadFailed = true;
  }
}
